define('modules/eventTracking/main',["jQuery", "T1", "T1Module"], function ($, T1, T1Module) {
  return new T1Module({
    name: "eventTracking",
    viewCfgs: {
      list: {}
    },
    defaultView: "list"
  });
});
